import { useEffect, useState } from 'react';

/** Поле поиска списка: печатается сразу, в адрес уходит через 300 мс. */
export function useDebouncedSearch(value: string | null, commit: (q: string | null) => void) {
  const [text, setText] = useState(value ?? '');
  useEffect(() => setText(value ?? ''), [value]);
  useEffect(() => {
    const t = window.setTimeout(() => {
      if ((text.trim() || null) !== (value || null)) commit(text.trim() || null);
    }, 300);
    return () => window.clearTimeout(t);
    // commit стабилен: из useListParams
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);
  return [text, setText] as const;
}
